import { setReportName } from "@/entities/report/slice";
import { Loader, useAppSelector } from "@/shared";
import { message } from "antd";
import { useEffect } from "react";

export const ReportLoader = () => {
  const { isGenerateReport, errorReport, reportName } = useAppSelector(
    (state) => state.reports,
  );
  const [messageApi, contextHandler] = message.useMessage();

  useEffect(() => {
    if (isGenerateReport) {
      messageApi.open({
        type: "loading",
        content: `Генерация ${reportName}. Пожалуйста, подождите...`,
        duration: 0,
      });
    } else {
      messageApi.destroy();
      if (errorReport) {
        message.open({
          type: "error",
          content: errorReport,
          duration: 5,
        });
      } else if (reportName) {
        message.open({
          type: "success",
          content: `Генерация ${reportName} завершена`,
          duration: 5,
        });
        setReportName(null);
      }
    }
  }, [isGenerateReport]);

  return <>{contextHandler}</>;
};
